import React from 'react';

interface SensitiveCredentialProps {
  value?: string | number | null;
  label?: string;
}

export const SensitiveCredential: React.FC<SensitiveCredentialProps> = ({ value, label = 'activation code' }) => {
  const [visible, setVisible] = React.useState(false);
  const text = value == null ? '' : String(value);

  React.useEffect(() => {
    if (!visible) return;
    const timer = window.setTimeout(() => setVisible(false), 30_000);
    return () => window.clearTimeout(timer);
  }, [visible]);

  if (!text) return <span className="text-gray-400">—</span>;

  return (
    <span className="inline-flex items-center gap-1.5" onClick={(event) => event.stopPropagation()}>
      <span className="font-mono text-sm bg-gray-100 px-2 py-0.5 rounded" aria-live="polite">
        {visible ? text : '••••••'}
      </span>
      <button type="button" onClick={() => setVisible(current => !current)} className="text-xs text-emerald-700 underline">
        {visible ? 'Hide' : 'View'} <span className="sr-only">{label}</span>
      </button>
      {visible && (
        <button type="button" onClick={() => navigator.clipboard?.writeText(text)} className="text-xs text-gray-600 underline">
          Copy <span className="sr-only">{label}</span>
        </button>
      )}
    </span>
  );
};
